const A = ["#55B1A7"], _ = [...A, "#0294E8"], o = [..._, "#0243AC"], t = [..._, "#0EEC5C", o[2]];
export {
  A as POI_3_TA1,
  _ as POI_3_TA2,
  o as POI_3_TA3,
  t as POI_3_TA4
};
//# sourceMappingURL=index.es5580.js.map
